import { Injectable } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";

import { ODataFilterBuilder } from "../odataFilterBuilder";

@Injectable()
export class ODataFilterFactoryService
{
    private $filter?: string;

    constructor(
        activatedRoute: ActivatedRoute)
    {
        activatedRoute.queryParamMap
            .subscribe((paramMap: ParamMap) =>
            {
                this.$filter = paramMap.get("$filter");
            });
    }

    /** @deprecated - just use `ODataFilterBuilder` locally */
    createBuilder(): ODataFilterBuilder
    {
        return new ODataFilterBuilder<Record<string, unknown>>();
    }

    /** @deprecated - just use `ODataFilterBuilder<T>` locally */
    createBuilderFor<T extends object>(): ODataFilterBuilder<T>
    {
        return new ODataFilterBuilder<T>();
    }

    /** @deprecated - just use ActivatedRoute locally... this doesn't need to be provided here.... */
    getFilterFromLocation(): string
    {
        return this.$filter
            ? `$filter=${this.$filter}`
            : undefined;
    }

    parseOdataFilter(filter: string): Record<string, string>
    {
        const map: Record<string, string> = {};
        try
        {
            if (!filter)
            {
                return map;
            }
            filter = filter.replace("$filter=", "");
            const filterClauses: string[] = filter.split(" and ");
            filterClauses.forEach(f =>
            {
                const keyAndValue = f.split(" eq ");
                let value = keyAndValue[1];
                const matches = /^'([^']+)'$/.exec(value);
                if (matches)
                {
                    value = matches[1];
                }
                map[keyAndValue[0]] = decodeURIComponent(value);
            });
            return map;
        }
        catch (error)
        {
            console.log("ODataFilterFactoryService.parseOdataFilter is squashing an error....", error);
            return map;
        }
    }

    parseOdataFilterFromLocation(): Record<string, string>
    {
        return this.parseOdataFilter(this.getFilterFromLocation());
    }

    removeFilterClause(property: string, filter: string): string
    {
        const parsed = this.parseOdataFilter(filter);
        let newFilter = "";
        Object.keys(parsed).forEach(clause =>
        {
            if (clause !== property)
            {
                let and = "";
                if (newFilter !== "")
                    and = " and ";
                newFilter += `${and}${clause} eq ${parsed[clause]}`;
            }
        });

        return newFilter;
    }
}
